import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { useTranslation } from '../../../locales';
import { useLanguageStore } from '../../../stores/languageStore';
import PPGFilteredDataChart from './PPGFilteredDataChart';
import PPGSignalQualityChart from './PPGSignalQualityChart';
import PPGIndexesChart from './PPGIndexesChart';

const PPGVisualizer: React.FC = () => {
  const { currentLanguage } = useLanguageStore();
  const t = useTranslation(currentLanguage);

  return (
    <div className="space-y-6">
      {/* 제목 */}
      <Card className="p-4">
        <CardHeader className="p-0">
          <CardTitle className="font-medium">
            {t.visualizer.ppgTitle}
          </CardTitle>
          <CardDescription className="text-sm text-muted-foreground">
            {t.visualizer.ppgDesc}
          </CardDescription>
        </CardHeader>
      </Card>

      {/* 상단: 필터링된 PPG 신호 | PPG 신호 품질 지수 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-4">
          <CardHeader className="p-0 mb-4">
            <CardTitle className="font-medium">
              {t.visualizer.filteredPPG}
            </CardTitle>
            <CardDescription className="text-sm text-muted-foreground">
              {t.visualizer.filteredPPGDesc}
            </CardDescription>
          </CardHeader>
          <CardContent className="p-0">
            <PPGFilteredDataChart />
          </CardContent>
        </Card>
        
        <Card className="p-4">
          <CardHeader className="p-0 mb-4">
            <CardTitle className="font-medium">
              {t.visualizer.ppgSQI}
            </CardTitle>
            <CardDescription className="text-sm text-muted-foreground">
              {t.visualizer.ppgSQIDesc}
            </CardDescription>
          </CardHeader>
          <CardContent className="p-0">
            <PPGSignalQualityChart />
          </CardContent>
        </Card>
      </div>

      {/* 하단: PPG 분석 지수 (전체 폭) */}
      <Card className="p-4">
        <CardHeader className="p-0 mb-4">
          <CardTitle className="font-medium">
            {t.visualizer.hrvIndexes}
          </CardTitle>
          <CardDescription className="text-sm text-muted-foreground">
            {t.visualizer.hrvIndexesDesc}
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <PPGIndexesChart />
        </CardContent>
      </Card>
    </div>
  );
};

export default PPGVisualizer;
